"use client";
import React from "react";
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuTrigger,
  navigationMenuTriggerStyle,
} from "./ui/navigation-menu";
import { NavbarItem } from "./navbar";
import { Link } from "./link";
import { useLocale } from "next-intl";

export default function DesktopNavbar({ items }: { items: NavbarItem[] }) {
  const locale = useLocale();
  return (
    <NavigationMenu className="mx-auto hidden lg:flex">
      <NavigationMenuList>
        {items.map((item) => (
          <NavigationMenuItem key={`navbar-${item.label}`}>
            {item.href !== undefined ? (
              <NavigationMenuLink
                className={navigationMenuTriggerStyle()}
                asChild
              >
                <Link
                  className="!px-4 hover:no-underline cursor-pointer"
                  href={item.href![locale as keyof typeof item.href]}
                  title={item.label}
                >
                  {item.label}
                </Link>
              </NavigationMenuLink>
            ) : (
              <>
                <NavigationMenuTrigger>{item.label}</NavigationMenuTrigger>
                <NavigationMenuContent asChild>
                  <ul className="grid gap-3 p-3 bg-card !border-0 w-[200px]">
                    {item.children?.map((child) => (
                      <li key={`navbar-${item.label}-${child.label}`}>
                        <NavigationMenuLink asChild>
                          <Link
                            className="cursor-pointer w-full text-base text-card-foreground !px-3 hover:no-underline hover:bg-primary/10 rounded-md select-none items-center justify-start"
                            header
                            href={child.href![locale as keyof typeof item.href]}
                            title={child.label}
                          >
                            {child.label}
                          </Link>
                        </NavigationMenuLink>
                      </li>
                    ))}
                  </ul>
                </NavigationMenuContent>
              </>
            )}
          </NavigationMenuItem>
        ))}
      </NavigationMenuList>
    </NavigationMenu>
  );
}
